export default __webpack_public_path__ + "static/media/partner16.63f91a5a.webp";